import { render } from "./MiraGarden.vue?vue&type=template&id=c1bc3e84&scoped=true&lang=pug"
import script from "./MiraGarden.vue?vue&type=script&lang=js"
export * from "./MiraGarden.vue?vue&type=script&lang=js"

import "./MiraGarden.vue?vue&type=style&index=0&id=c1bc3e84&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1bc3e84"]])

export default __exports__